import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IResponse } from 'projects/lib-ui/src/shared/interfaces/response';

@Injectable()
export class DeviceService {
  private readonly URI_API = environment.URLAPI + 'Devices';

  constructor(private readonly httpClient: HttpClient) {}

  linkDevice(
    deviceId: string,
    latitude: string,
    longitude: string
  ): Observable<IResponse<any>> {
    return this.httpClient.patch<IResponse<any>>(
      `${this.URI_API}/link/?DeviceId=${deviceId}&Latitude=${latitude}&Longitude=${longitude}`,
      {}
    );
  }

  unLinkDevice(deviceId: string): Observable<IResponse<any>> {
    return this.httpClient.patch<IResponse<any>>(
      `${this.URI_API}/unlink/${deviceId}`,
      {}
    );
  }

  checkDeviceExists(deviceId: string): Observable<IResponse<boolean>> {
    return this.httpClient.get<IResponse<boolean>>(
      `${this.URI_API}/${deviceId}/check-branch`
    );
  }
}
